import { Controller } from "stimulus"
import { EventTrackerService } from "../services/event_tracker_service"

export default class extends Controller {
  static targets = ["modal"]
  static values = {
    openEventName: String,
    openEventProperties: Object,
    closeEventName: String,
    closeEventProperties: Object
  }

  connect() {
    // Only trackEvent() is needed here — initialize() also (re-)binds the IRS-link
    // and blog-search listeners the layout's own event-tracker controller already
    // sets up once globally; calling it again would double those events.
    this.eventTracker = new EventTrackerService()

    this._onKeydown = (event) => {
      if (event.key !== "Escape") return

      this.#hide({ dismissed: true })
    }
    document.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
  }

  open(event) {
    if (event) event.preventDefault()
    if (!this.hasModalTarget) return
    if (this.#isOpen()) return

    this.modalTarget.style.display = "flex"
    this.#track(this.openEventNameValue, this.openEventPropertiesValue)
  }

  close(event) {
    if (event) event.preventDefault()
    if (!this.hasModalTarget) return

    // Overlay has click->close; ignore bubbled clicks from modal content so only
    // true backdrop clicks close. Close button / CTA still call close directly.
    if (event?.currentTarget === this.modalTarget && event.target !== this.modalTarget) {
      return
    }

    this.#hide({ dismissed: event?.currentTarget?.dataset.dismissTrigger === "true" })
  }

  #hide({ dismissed }) {
    if (!this.hasModalTarget) return
    if (!this.#isOpen()) return

    this.modalTarget.style.display = "none"

    if (dismissed) this.#track(this.closeEventNameValue, this.closeEventPropertiesValue)
  }

  // `shared/modal/overlay` hides with inline display, not a `tw-hidden` class.
  #isOpen() {
    return this.modalTarget.style.display !== "none"
  }

  #track(eventName, properties) {
    if (!eventName) return

    this.eventTracker.trackEvent(eventName, properties || {}, this.element)
  }
}
